import { createFileRoute } from '@tanstack/react-router'
import { AdminPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/admin/$section')({
  head: () => noIndexRouteHead('admin', 'en'),
  component: AdminPage,
})
